"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8243],{

/***/ 28243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SearchForm_Form; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Label/Label.js
var Label = __webpack_require__(98028);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Select/Select.js
var Select = __webpack_require__(16031);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/theme/theme.js + 1 modules
var theme = __webpack_require__(15072);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/FormField/FormField.js + 1 modules
var FormField = __webpack_require__(55404);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Checkbox/Checkbox.js
var Checkbox = __webpack_require__(67905);
// EXTERNAL MODULE: ./node_modules/@pcln/whitelabel-components/dist/esm/hooks/usePartner.js
var usePartner = __webpack_require__(40383);
// EXTERNAL MODULE: ./node_modules/@pcln/whitelabel-components/dist/esm/hooks/usePartnerPromo.js
var usePartnerPromo = __webpack_require__(9719);
// EXTERNAL MODULE: ./node_modules/@pcln/date-picker/dist/esm/index.js + 51 modules
var esm = __webpack_require__(94319);
// EXTERNAL MODULE: ./node_modules/@pcln/feature-components/dist/esm/useFeature/useFeature.js
var useFeature = __webpack_require__(66252);
// EXTERNAL MODULE: ./src/components/CalenderWrapperBox.styled.ts
var CalenderWrapperBox_styled = __webpack_require__(73694);
// EXTERNAL MODULE: ./src/components/DateField.tsx
var DateField = __webpack_require__(85495);
// EXTERNAL MODULE: ./src/components/ShadowEffect.tsx
var ShadowEffect = __webpack_require__(72356);
// EXTERNAL MODULE: ./src/components/StyledHeading/index.tsx
var StyledHeading = __webpack_require__(5527);
// EXTERNAL MODULE: ./src/components/SearchFormButton/index.tsx
var SearchFormButton = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/components/TypeAhead/index.tsx + 13 modules
var TypeAhead = __webpack_require__(15146);
// EXTERNAL MODULE: ./src/utils/date-helper.tsx
var date_helper = __webpack_require__(3206);
// EXTERNAL MODULE: ./src/components/Popover.tsx + 2 modules
var Popover = __webpack_require__(28690);
// EXTERNAL MODULE: ./src/components/TravelerSelection/constants.ts
var constants = __webpack_require__(65692);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(80404);
// EXTERNAL MODULE: ./src/components/TravelerSelection/TravelerSelection.tsx + 9 modules
var TravelerSelection = __webpack_require__(19918);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(1377);
// EXTERNAL MODULE: ./src/hooks/useTabGroup.ts
var useTabGroup = __webpack_require__(32585);
// EXTERNAL MODULE: ./src/hooks/useContentfulSearchFormHeadlines.ts
var useContentfulSearchFormHeadlines = __webpack_require__(34752);
// EXTERNAL MODULE: ./src/hooks/useSeti.ts
var useSeti = __webpack_require__(22091);
// EXTERNAL MODULE: ./src/components/Packages/SearchForm/utils.ts
var utils = __webpack_require__(33271);
// EXTERNAL MODULE: ./src/components/Packages/SearchForm/TripTypes.ts
var TripTypes = __webpack_require__(6244);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Radio/Radio.js
var Radio = __webpack_require__(65753);
// EXTERNAL MODULE: ./node_modules/ramda/es/pipe.js + 5 modules
var pipe = __webpack_require__(71387);
// EXTERNAL MODULE: ./node_modules/ramda/es/set.js + 1 modules
var set = __webpack_require__(56892);
// EXTERNAL MODULE: ./node_modules/ramda/es/lensIndex.js + 1 modules
var lensIndex = __webpack_require__(12867);
;// CONCATENATED MODULE: ./src/utils/ramda-helper.ts

// eslint-disable-next-line import/prefer-default-export
function swap(index1, index2, list) {
    if (index1 < 0 || index2 < 0 || index1 > list.length - 1 || index2 > list.length - 1) {
        return list // index out of bound
        ;
    }
    return (0,pipe/* default */.Z)((0,set/* default */.Z)((0,lensIndex/* default */.Z)(index1), list[index2]), (0,set/* default */.Z)((0,lensIndex/* default */.Z)(index2), list[index1]))(list);
}

;// CONCATENATED MODULE: ./src/components/Packages/SearchForm/TripTypeRadios.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}








var _obj;
var tripTypeProductMap = (_obj = {}, _defineProperty(_obj, TripTypes/* STAY_FLY */.b, [
    'hotel',
    'flight'
]), _defineProperty(_obj, TripTypes/* STAY_FLY_DRIVE */.Ss, [
    'hotel',
    'flight',
    'car'
]), _defineProperty(_obj, TripTypes/* FLY_DRIVE */.yv, [
    'flight',
    'car'
]), _defineProperty(_obj, TripTypes/* STAY_DRIVE */.Hl, [
    'hotel',
    'car'
]), _obj);
var defaultTripTypes = Object.values(TripTypes/* TripTypeInfos */.jb);
var mobileDefaultTripTypes = swap(1, 2, defaultTripTypes);
var singleHotelTripTypes = defaultTripTypes.filter(function(type) {
    return ![
        TripTypes/* FLY_DRIVE */.yv,
        TripTypes/* STAY_DRIVE */.Hl
    ].includes(type.tripType);
});
var TripTypeRadios = function(param) {
    var setValue = param.setValue, watchTripType = param.watchTripType, register = param.register;
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), _isMobile = ref.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var isPricelineOnly = (0,useFeature/* default */.Z)('whiteLabel.isPricelineOnly', true);
    var products = (0,usePartner/* default */.Z)('config.searchForm.products');
    var isSingleHotel = (0,usePartner/* default */.Z)('config.products.hotel.singleLocation');
    var pricelineTripTypes = isMobile ? mobileDefaultTripTypes : defaultTripTypes;
    var getMandatoryTripTypes = function() {
        if (products) {
            var mandatoryProducts = Object.keys(products).filter(function(productKey) {
                return products[productKey].isMandatory;
            });
            var mandatoryTrips = Object.keys(TripTypes/* TripTypeInfos */.jb).filter(function(tripTypeKey) {
                return mandatoryProducts.every(function(mandatoryProduct) {
                    return tripTypeProductMap[tripTypeKey].includes(mandatoryProduct);
                });
            });
            return mandatoryTrips.map(function(tripKey) {
                return TripTypes/* TripTypeInfos */.jb[tripKey];
            });
        }
        if (isSingleHotel) {
            return singleHotelTripTypes;
        }
        return pricelineTripTypes;
    };
    var tripTypes = getMandatoryTripTypes();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        alignItems: [
            'left',
            null,
            'center'
        ],
        flexDirection: [
            'column',
            null,
            'row'
        ],
        justifyContent: "space-between",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
            flexDirection: [
                isPricelineOnly ? 'row' : 'column',
                null,
                'row'
            ],
            flexWrap: "wrap",
            children: tripTypes.map(function(typeInfo) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    mr: [
                        0,
                        null,
                        3
                    ],
                    alignItems: "center",
                    width: isMobile ? 1 / 2 : 'auto',
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TripTypes/* TripTypeLabel */.sc, {
                        fontSize: 0,
                        fontWeight: 500,
                        nowrap: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                id: typeInfo.id,
                                type: "radio",
                                name: "tripType",
                                value: typeInfo.tripType,
                                ref: register,
                                checked: watchTripType === typeInfo.tripType,
                                onChange: function(e) {
                                    setValue('tripType', e.target.value);
                                }
                            }),
                            ' ',
                            typeInfo.typeLabel
                        ]
                    })
                }, typeInfo.id);
            })
        })
    });
};
/* harmony default export */ var SearchForm_TripTypeRadios = (TripTypeRadios);

// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(934);
;// CONCATENATED MODULE: ./src/components/Packages/SearchForm/validation.ts


var LOCATION_REQUIRED = 'Please enter a city or airport';
var INVALID_DATE = 'Please select valid dates';
var DISALLOW_INFANT_INTL_FLIGHT = 'Sorry, we do not offer lap infant seating on international flights';
var INFANT_CAPACITY_LIMIT = 'Only one infant per adult is allowed';
var CHILD_AGE_REQUIRED = "Please enter children's age to get the best price for your group";
var TRAVELERS_PER_ROOM = 4;
var MAXIMUM_BUNDLE_GUEST_COUNT = 8;
var ROOM_CAPACITY_ERROR = 'Rooms accommodate up to 4 people. You may need additional rooms for your group';
var BUNDLE_MAX_CAPACITY_ERROR = 'Bundles accommodate up to 8 people. You may need an additional bundle for your group';
var intlStartLocation = function(startLocationObject) {
    return startLocationObject && typeof startLocationObject.countryCode === 'string' && startLocationObject.countryCode.toUpperCase() !== 'US';
};
var intlEndLocation = function(endLocationObject) {
    return endLocationObject && typeof endLocationObject.countryCode === 'string' && endLocationObject.countryCode.toUpperCase() !== 'US';
};
var isInfantFound = function(childrenAges) {
    return Array.isArray(childrenAges) && childrenAges.some(function(age) {
        return Number(age) === 0;
    });
};
var isStartLocationWithInfant = function(startLocationObject, childrenAges) {
    return intlStartLocation(startLocationObject) && isInfantFound(childrenAges);
};
var isEndLocationWithInfant = function(endLocationObject, childrenAges) {
    return intlEndLocation(endLocationObject) && isInfantFound(childrenAges);
};
var isChildrenAgeDataValid = function(childrenAges) {
    return Array.isArray(childrenAges) && childrenAges.length >= 0;
};
var numOfValidAges = function(childrenAges) {
    return Array.isArray(childrenAges) ? childrenAges.filter(function(age) {
        return age >= 0;
    }) : [];
};
var isInfantOnInternationalTravel = function(startLocation, endLocation, childrenAges) {
    if (isStartLocationWithInfant(startLocation, childrenAges) || isEndLocationWithInfant(endLocation, childrenAges)) {
        return DISALLOW_INFANT_INTL_FLIGHT;
    }
    return '';
};
function handleIsInfantOnInternationalTravel() {
    var _parent = this.parent, startLocation = _parent.startLocation, endLocation = _parent.endLocation, childrenAges = _parent.childrenAges;
    if (isStartLocationWithInfant(startLocation, childrenAges) || isEndLocationWithInfant(endLocation, childrenAges)) {
        return false;
    }
    return true;
}
var isRoomCompacityReached = function(adultCount, childrenCount, tripType, roomCount, isMoreRoomCapacityAllowed) {
    var travelerCount = adultCount + childrenCount;
    var allowedTravelerCount = isMoreRoomCapacityAllowed ? MAXIMUM_BUNDLE_GUEST_COUNT : roomCount * TRAVELERS_PER_ROOM;
    if (allowedTravelerCount < travelerCount && tripType.includes(TripTypes/* HOTEL */.IN)) {
        return isMoreRoomCapacityAllowed ? BUNDLE_MAX_CAPACITY_ERROR : ROOM_CAPACITY_ERROR;
    }
    return '';
};
function handleIsRoomCompacityReached() {
    var _parent = this.parent, adultCount = _parent.adultCount, childrenCount = _parent.childrenCount, tripType = _parent.tripType, roomCount = _parent.roomCount;
    var ref = this.options.context || {}, _isMoreRoomCapacityAllowed = ref.isMoreRoomCapacityAllowed, isMoreRoomCapacityAllowed = _isMoreRoomCapacityAllowed === void 0 ? false : _isMoreRoomCapacityAllowed;
    var travelerCount = adultCount + childrenCount;
    var allowedTravelerCount = isMoreRoomCapacityAllowed ? MAXIMUM_BUNDLE_GUEST_COUNT : roomCount * TRAVELERS_PER_ROOM;
    if (allowedTravelerCount < travelerCount && tripType.includes(TripTypes/* HOTEL */.IN)) {
        return false;
    }
    return true;
}
function handleIsChildrenAgeProvided() {
    var _parent = this.parent, childrenCount = _parent.childrenCount, childrenAges = _parent.childrenAges;
    if (childrenCount > 0 && isChildrenAgeDataValid(childrenAges) && childrenCount !== numOfValidAges(childrenAges).length) {
        return false;
    }
    return true;
}
var isChildrenAgeProvided = function(childrenCount, childrenAges) {
    if (childrenCount > 0 && isChildrenAgeDataValid(childrenAges) && childrenCount !== numOfValidAges(childrenAges).length) {
        return CHILD_AGE_REQUIRED;
    }
    return '';
};
var isInfantLimitReachedPackages = function(adultCount, childrenAges, tripType) {
    var lapInfants = childrenAges.filter(function(age) {
        return age === 0;
    });
    var infantCount = lapInfants.length;
    if (tripType.includes(TripTypes/* FLIGHT */.qQ) && infantCount > adultCount) {
        return INFANT_CAPACITY_LIMIT;
    }
    return '';
};
var searchFormSchema = es/* object */.Ry().shape({
    tripType: es/* string */.Z_(),
    partialStay: es/* bool */.Xg(),
    startLocation: es/* object */.Ry().nullable().when('tripType', {
        is: TripTypes/* STAY_DRIVE */.Hl,
        then: es/* object */.Ry().nullable(),
        otherwise: es/* object */.Ry().nullable().required(LOCATION_REQUIRED)
    }),
    endLocation: es/* object */.Ry().nullable().required(LOCATION_REQUIRED),
    rcLocation: es/* object */.Ry().nullable().when('pickupCarSomewhere', {
        is: true,
        then: es/* object */.Ry().nullable().required(LOCATION_REQUIRED),
        otherwise: es/* object */.Ry().nullable()
    }),
    startDate: es/* string */.Z_().required(INVALID_DATE),
    endDate: es/* string */.Z_().required(INVALID_DATE),
    hotelStartDate: es/* string */.Z_().when('partialStay', {
        is: true,
        then: es/* string */.Z_().required(INVALID_DATE),
        otherwise: es/* string */.Z_()
    }),
    hotelEndDate: es/* string */.Z_().when('partialStay', {
        is: true,
        then: es/* string */.Z_().required(INVALID_DATE),
        otherwise: es/* string */.Z_()
    }),
    rcPickupDate: es/* string */.Z_().when('pickupCarSomewhere', {
        is: true,
        then: es/* string */.Z_().nullable().required(INVALID_DATE),
        otherwise: es/* string */.Z_()
    }),
    rcDropoffDate: es/* string */.Z_().when('pickupCarSomewhere', {
        is: true,
        then: es/* string */.Z_().nullable().required(INVALID_DATE),
        otherwise: es/* string */.Z_()
    }),
    isInfantOnInternationalTravel: es/* string */.Z_().test('isInfantOnInternationalTravel', DISALLOW_INFANT_INTL_FLIGHT, handleIsInfantOnInternationalTravel),
    isChildrenAgeProvided: es/* string */.Z_().test('isChildrenAgeProvided', CHILD_AGE_REQUIRED, handleIsChildrenAgeProvided),
    isRoomCompacityReached: es/* string */.Z_().test('isRoomCompacityReached', ROOM_CAPACITY_ERROR, handleIsRoomCompacityReached)
});

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/react-hook-form.es.js
var react_hook_form_es = __webpack_require__(63523);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@pcln/experimentation/dist/esm/index.js + 4 modules
var dist_esm = __webpack_require__(80460);
// EXTERNAL MODULE: ./src/constants/analytics.ts
var constants_analytics = __webpack_require__(92265);
// EXTERNAL MODULE: ./src/utils/packages-room-count.ts
var packages_room_count = __webpack_require__(16248);
;// CONCATENATED MODULE: ./src/components/Packages/SearchForm/FormContainer.tsx








var HOTEL = 'STAY';
function FormContainer(param) {
    var children = param.children, initialState = param.initialState, onSubmit = param.onSubmit, fields = param.fields, searchFormSchema = param.searchFormSchema, isMoreRoomCapacityAllowed = param.isMoreRoomCapacityAllowed;
    var ref = (0,react_hook_form_es/* useForm */.cI)({
        defaultValues: initialState,
        mode: 'onSubmit',
        validationSchema: searchFormSchema,
        reValidateMode: 'onChange',
        validationContext: {
            isMoreRoomCapacityAllowed: isMoreRoomCapacityAllowed
        }
    }), register = ref.register, unregister = ref.unregister, setValue = ref.setValue, clearError = ref.clearError, formState = ref.formState, handleSubmit = ref.handleSubmit, watch = ref.watch, errors = ref.errors;
    (0,react.useEffect)(function() {
        fields.forEach(function(name) {
            register({
                name: name
            });
        });
        return function() {
            fields.forEach(function(name) {
                unregister(name);
            });
        };
    }, [
        fields,
        register,
        unregister
    ]);
    var ref1 = watch(), watchTripType = ref1.tripType, watchPartialStay = ref1.partialStay, watchStartLocation = ref1.startLocation, watchEndLocation = ref1.endLocation, watchStartDate = ref1.startDate, watchEndDate = ref1.endDate, watchRoomCount = ref1.roomCount, watchAdultCount = ref1.adultCount, watchChildrenAges = ref1.childrenAges, watchChildrenCount = ref1.childrenCount, watchHotelStartDate = ref1.hotelStartDate, watchHotelEndDate = ref1.hotelEndDate, watchIncludeBasicEconomy = ref1.includeBasicEconomy, watchPickupCarSomewhere = ref1.pickupCarSomewhere, watchPickupCarIncludeAirport = ref1.pickupCarIncludeAirport, watchRcLocation = ref1.rcLocation, watchRcPickupDate = ref1.rcPickupDate, watchRcDropoffDate = ref1.rcDropoffDate, watchRcPickupTime = ref1.rcPickupTime, watchRcDropoffTime = ref1.rcDropoffTime, watchGaCategory = ref1.gaCategory;
    // PKG_FE_SEARCH_FORM_HOTEL_NUM_ADULTS_RESTRICTION
    (0,react.useEffect)(function() {
        if (watchTripType.includes(HOTEL) && (0,packages_room_count/* default */.Z)(watchRoomCount, watchAdultCount + watchChildrenCount)) {
            dist_esm/* default.fireImpression */.Z.fireImpression('PKG_FE_SEARCH_FORM_HOTEL_NUM_ADULTS_RESTRICTION');
        }
    }, [
        watchTripType,
        watchRoomCount,
        watchAdultCount,
        watchChildrenCount
    ]);
    (0,react.useEffect)(function() {
        clearError('startLocation');
    }, [
        clearError,
        watchStartLocation
    ]);
    (0,react.useEffect)(function() {
        clearError('endLocation');
    }, [
        clearError,
        watchEndLocation
    ]);
    (0,react.useEffect)(function() {
        clearError('rcLocation');
    }, [
        clearError,
        watchRcLocation
    ]);
    (0,react.useEffect)(function() {
        clearError('startDate');
    }, [
        clearError,
        watchStartDate
    ]);
    (0,react.useEffect)(function() {
        clearError('endDate');
    }, [
        clearError,
        watchEndDate
    ]);
    (0,react.useEffect)(function() {
        clearError('hotelStartDate');
    }, [
        clearError,
        watchHotelStartDate,
        watchPartialStay
    ]);
    (0,react.useEffect)(function() {
        clearError('hotelEndDate');
    }, [
        clearError,
        watchHotelEndDate,
        watchPartialStay
    ]);
    (0,react.useEffect)(function() {
        clearError('hotelStartDateInRange');
    }, [
        clearError,
        watchPartialStay,
        watchStartDate,
        watchHotelStartDate
    ]);
    (0,react.useEffect)(function() {
        clearError('hotelEndDateInRange');
    }, [
        clearError,
        watchPartialStay,
        watchEndDate,
        watchHotelEndDate
    ]);
    (0,react.useEffect)(function() {
        clearError('rcPickupDate');
    }, [
        clearError,
        watchRcPickupDate
    ]);
    (0,react.useEffect)(function() {
        clearError('rcDropoffDate');
    }, [
        clearError,
        watchRcDropoffDate
    ]);
    (0,react.useEffect)(function() {
        clearError('isInfantOnInternationalTravel');
    }, [
        clearError,
        watchStartLocation,
        watchEndLocation,
        watchChildrenAges
    ]);
    (0,react.useEffect)(function() {
        clearError('isChildrenAgeProvided');
    }, [
        clearError,
        watchChildrenCount,
        watchChildrenAges
    ]);
    (0,react.useEffect)(function() {
        clearError('isRoomCompacityReached');
    }, [
        clearError,
        watchAdultCount,
        watchChildrenCount,
        watchTripType,
        watchRoomCount
    ]);
    (0,react.useEffect)(function() {
        if (watchPickupCarSomewhere) clearError('rcDropoffDate');
    }, [
        clearError,
        watchPickupCarSomewhere
    ]);
    var pathname = (0,router.useRouter)().pathname;
    var ANALYTICS_CATEGORY = constants_analytics/* ANALYTICS_CATEGORIES */.ZP[pathname];
    (0,react.useEffect)(function() {
        setValue('gaCategory', ANALYTICS_CATEGORY);
    }, [
        setValue,
        ANALYTICS_CATEGORY
    ]);
    (0,react.useEffect)(function() {
        if (formState.submitCount && !formState.isValid) {
            analytics/* default.fireEvent */.Z.fireEvent({
                category: ANALYTICS_CATEGORY,
                action: 'VP Search Button',
                label: constants_analytics/* INVALID */.UI
            });
        }
    }, [
        formState.isValid,
        formState.submitCount,
        ANALYTICS_CATEGORY
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        "aria-label": "packages-search-form",
        onSubmit: handleSubmit(onSubmit),
        children: children({
            setValue: setValue,
            errors: errors,
            register: register,
            watchState: {
                watchTripType: watchTripType,
                watchAdultCount: watchAdultCount,
                watchRoomCount: watchRoomCount,
                watchChildrenAges: watchChildrenAges,
                watchChildrenCount: watchChildrenCount,
                watchHotelStartDate: watchHotelStartDate,
                watchHotelEndDate: watchHotelEndDate,
                watchStartDate: watchStartDate,
                watchEndDate: watchEndDate,
                watchPartialStay: watchPartialStay,
                watchStartLocation: watchStartLocation,
                watchEndLocation: watchEndLocation,
                watchIncludeBasicEconomy: watchIncludeBasicEconomy,
                watchPickupCarSomewhere: watchPickupCarSomewhere,
                watchPickupCarIncludeAirport: watchPickupCarIncludeAirport,
                watchRcLocation: watchRcLocation,
                watchRcPickupDate: watchRcPickupDate,
                watchRcDropoffDate: watchRcDropoffDate,
                watchRcPickupTime: watchRcPickupTime,
                watchRcDropoffTime: watchRcDropoffTime,
                watchGaCategory: watchGaCategory
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Packages/SearchForm/Form.tsx
function Form_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Form_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  &::-ms-expand {\n    display: none;\n  }\n  cursor: pointer;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





























var LocationSelector = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 5155).then(__webpack_require__.bind(__webpack_require__, 55155)).then(function(mod) {
        return mod.LocationSelector;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55155)
            ];
        }
    }
});
var InlineBlockBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-648da906-0"
})(_templateObject());
var FlexLabel = (0,styled_components_browser_esm/* default */.ZP)(Label/* default */.Z).withConfig({
    componentId: "sc-648da906-1"
})(_templateObject1());
var trackOneWayFlightLinkClick = function() {
    analytics/* default.fireEvent */.Z.fireEvent({
        action: 'Search Form Link',
        label: 'I need a one-way flight'
    });
};
var StyledSelect = (0,styled_components_browser_esm/* default */.ZP)(Select/* default */.Z).withConfig({
    componentId: "sc-648da906-2"
})(_templateObject2(), theme/* theme.colors.white */.rS.colors.white);
var TimeField = function(_param) /*#__PURE__*/ {
    var name = _param.name, label = _param.label, props = _objectWithoutProperties(_param, [
        "name",
        "label"
    ]);
    return (0,jsx_runtime.jsxs)(FormField/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelect, _objectSpread({}, props, {
                id: name,
                name: name,
                children: (0,date_helper/* getTimeOptions */.wU)()
            }))
        ]
    });
};
var formatOneWayHref = function(param) {
    var watchTripType = param.watchTripType, startLocation = param.watchStartLocation, endLocation = param.watchEndLocation, watchStartDate = param.watchStartDate, watchEndDate = param.watchEndDate, watchRoomCount = param.watchRoomCount, watchAdultCount = param.watchAdultCount, watchChildrenCount = param.watchChildrenCount, watchChildrenAges = param.watchChildrenAges, watchHotelStartDate = param.watchHotelStartDate, watchHotelEndDate = param.watchHotelEndDate, watchPartialStay = param.watchPartialStay, watchIncludeBasicEconomy = param.watchIncludeBasicEconomy;
    var stringifiedQuery = query_string.stringify(_objectSpread({
        'flight-code': 'OW',
        'trip-type': watchTripType,
        'origin-item': startLocation === null || startLocation === void 0 ? void 0 : startLocation.itemName,
        'origin-id': startLocation === null || startLocation === void 0 ? void 0 : startLocation.id,
        'origin-type': startLocation === null || startLocation === void 0 ? void 0 : startLocation.type,
        'origin-city': startLocation === null || startLocation === void 0 ? void 0 : startLocation.cityName,
        'origin-state': startLocation === null || startLocation === void 0 ? void 0 : startLocation.provinceName,
        'origin-state-code': startLocation === null || startLocation === void 0 ? void 0 : startLocation.stateCode,
        'origin-country': startLocation === null || startLocation === void 0 ? void 0 : startLocation.country,
        'origin-country-code': startLocation === null || startLocation === void 0 ? void 0 : startLocation.countryCode,
        'destination-item': endLocation === null || endLocation === void 0 ? void 0 : endLocation.itemName,
        'destination-id': endLocation === null || endLocation === void 0 ? void 0 : endLocation.id,
        'destination-type': endLocation === null || endLocation === void 0 ? void 0 : endLocation.type,
        'destination-city': endLocation === null || endLocation === void 0 ? void 0 : endLocation.cityName,
        'destination-state': endLocation === null || endLocation === void 0 ? void 0 : endLocation.provinceName,
        'destination-state-code': endLocation === null || endLocation === void 0 ? void 0 : endLocation.stateCode,
        'destination-country': endLocation === null || endLocation === void 0 ? void 0 : endLocation.country,
        'destination-country-code': endLocation === null || endLocation === void 0 ? void 0 : endLocation.countryCode,
        'include-basic-economy': watchIncludeBasicEconomy,
        start: watchStartDate,
        end: watchEndDate,
        rooms: watchRoomCount,
        adults: watchAdultCount,
        children: watchChildrenCount,
        ages: JSON.stringify(watchChildrenAges)
    }, watchPartialStay ? {
        'hotel-start': watchHotelStartDate,
        'hotel-end': watchHotelEndDate
    } : {}));
    return "/shop/search/trips/?".concat(stringifiedQuery);
};
var Form = function(param1) {
    var onSubmit = param1.onSubmit, _isLandingPage = param1.isLandingPage, isLandingPage = _isLandingPage === void 0 ? true : _isLandingPage;
    var ref12, ref1, ref2;
    var isSingleHotel = (0,usePartner/* default */.Z)('config.products.hotel.singleLocation');
    var initialSearchValidPromotions = (0,usePartner/* default */.Z)('config.initialSearchboxValues.nextLandingActivePromo.validPromos');
    var initialSearchValues = (0,usePartnerPromo/* default */.Z)('config.initialSearchboxValues.nextLandingActivePromo.values', 'config.initialSearchboxValues.nextLanding', Array.isArray(initialSearchValidPromotions) ? initialSearchValidPromotions : []) || {};
    var isPricelineOnly = (0,useFeature/* default */.Z)('whiteLabel.isPricelineOnly', true);
    var toggleBasicEconomyBoxEnabled = (0,useFeature/* default */.Z)('whiteLabel.toggleBasicEconomyEnabled', false);
    var toggleBasicEconomyDefault = (0,useFeature/* default */.Z)('whiteLabel.toggleBasicEconomyDefault', true);
    var rentalCarEnabled = (0,useFeature/* default */.Z)('whiteLabel.packagesRentalCarEnabled', true);
    var ref3 = (0,useTabGroup/* default */.Z)(), registerTabElement = ref3.registerTabElement, focusNextElement = ref3.focusNextElement;
    var ref4 = (0,react.useContext)(BootstrapDataContext/* default */.Z), _isMobile = ref4.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var ref5 = (0,react.useState)(false), isCalendarOpen = ref5[0], setIsCalendarOpen = ref5[1];
    var ref6 = (0,react.useState)(false), isRcPickupCalendarOpen = ref6[0], setIsRcPickupCalendarOpen = ref6[1];
    var ref7 = (0,react.useState)(false), isRcDropoffCalendarOpen = ref7[0], setIsRcDropoffCalendarOpen = ref7[1];
    var ref8 = (0,react.useState)(false), isHotelCalendarOpen = ref8[0], setIsHotelCalendarOpen = ref8[1];
    var primaryHeadingText = 'Save up to $625 on your ';
    var secondaryHeadingText = !isMobile ? 'Book together for our best deals' : '';
    var partnerSearchForm = (0,usePartnerPromo/* default */.Z)('config.searchFormActivePromo', 'config.searchForm', (0,usePartner/* default */.Z)('config.searchFormActivePromo.validPromos') || []) || {};
    var partnerPrimaryHeading = partnerSearchForm.primaryHeading;
    var partnerSecondaryHeading = partnerSearchForm.secondaryHeading || secondaryHeadingText;
    var primaryFontColor = partnerSearchForm.primaryFontColor, secondaryFontColor = partnerSearchForm.secondaryFontColor;
    var buttonText = partnerSearchForm.buttonText || 'Find Your Trip';
    var partnerCallToAction = partnerSearchForm.callToAction;
    var callToAction = isPricelineOnly ? 'Book a hotel, flight or car with free cancellation for flexibility' : partnerCallToAction;
    var sameFlightHotelAndCarDestination = partnerSearchForm.sameFlightHotelAndCarDestination, defaultHotelAndCarDestination = partnerSearchForm.defaultHotelAndCarDestination;
    var ref9;
    var allowedPartnerOriginMap = (ref9 = (ref12 = partnerSearchForm.customFields) === null || ref12 === void 0 ? void 0 : ref12.origins) !== null && ref9 !== void 0 ? ref9 : {};
    var allowedPartnerAirports = (ref1 = partnerSearchForm.customFields) === null || ref1 === void 0 ? void 0 : ref1.airports;
    var allowedPartnerOrigins = Object.keys(allowedPartnerOriginMap).map(function(code) {
        return allowedPartnerAirports.find(function(airport) {
            return airport.airportCode === code;
        });
    });
    var ref10 = (0,react.useState)(((ref2 = partnerSearchForm.customFields) === null || ref2 === void 0 ? void 0 : ref2.destinations) || allowedPartnerAirports), allowedPartnerDestinations = ref10[0], setAllowedPartnerDestinations = ref10[1];
    var radioExperimentInitialState = _objectSpread({}, utils/* initialState */.E3, initialSearchValues, {
        includeBasicEconomy: !toggleBasicEconomyBoxEnabled || toggleBasicEconomyDefault,
        tripType: TripTypes/* STAY_FLY */.b
    });
    var searchForm = (0,useContentfulSearchFormHeadlines/* default */.Z)('searchForm');
    var isMoreRoomCapacityAllowed = (0,useSeti/* default */.Z)('PKG_FE_SEARCH_FORM_HOTEL_NUM_ADULTS_RESTRICTION', false) === 'VARIANT';
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormContainer, {
        onSubmit: onSubmit,
        fields: utils/* fields */.XU,
        initialState: radioExperimentInitialState,
        searchFormSchema: searchFormSchema,
        isMoreRoomCapacityAllowed: isMoreRoomCapacityAllowed,
        children: function(param2) {
            var setValue = param2.setValue, errors = param2.errors, register = param2.register, _watchState = param2.watchState, watchTripType = _watchState.watchTripType, watchAdultCount = _watchState.watchAdultCount, watchRoomCount = _watchState.watchRoomCount, watchChildrenAges = _watchState.watchChildrenAges, watchChildrenCount = _watchState.watchChildrenCount, watchHotelStartDate = _watchState.watchHotelStartDate, watchHotelEndDate = _watchState.watchHotelEndDate, watchStartDate = _watchState.watchStartDate, watchEndDate = _watchState.watchEndDate, watchPartialStay = _watchState.watchPartialStay, watchStartLocation = _watchState.watchStartLocation, watchEndLocation = _watchState.watchEndLocation, watchIncludeBasicEconomy = _watchState.watchIncludeBasicEconomy, watchPickupCarSomewhere = _watchState.watchPickupCarSomewhere, watchRcLocation = _watchState.watchRcLocation, watchRcPickupDate = _watchState.watchRcPickupDate, watchRcDropoffDate = _watchState.watchRcDropoffDate, watchRcPickupTime = _watchState.watchRcPickupTime, watchRcDropoffTime = _watchState.watchRcDropoffTime;
            var ref, ref11;
            var finalPrimaryHeadingText = (0,utils/* getTextString */.GS)(watchTripType)(primaryHeadingText);
            if (!partnerPrimaryHeading) {
                partnerPrimaryHeading = finalPrimaryHeadingText;
            }
            if (Object.keys(allowedPartnerOriginMap).length && watchEndLocation && !watchStartLocation) {
                allowedPartnerOrigins = Object.keys(allowedPartnerOriginMap).filter(function(code) {
                    return allowedPartnerOriginMap[code].includes(watchEndLocation.id) && code;
                }).map(function(code) {
                    return allowedPartnerAirports.find(function(airport) {
                        return airport.airportCode === code;
                    });
                });
            }
            var headline;
            var subheadline;
            if (isPricelineOnly) {
                var contentfulHeadline = isMobile ? searchForm === null || searchForm === void 0 ? void 0 : searchForm.mobileHeadline : searchForm === null || searchForm === void 0 ? void 0 : searchForm.headline;
                var contentfulSubheadline = isMobile ? searchForm === null || searchForm === void 0 ? void 0 : searchForm.mobileSubheadline : searchForm === null || searchForm === void 0 ? void 0 : searchForm.subheadline;
                headline = contentfulHeadline || finalPrimaryHeadingText;
                subheadline = contentfulSubheadline || secondaryHeadingText;
            }
            var carLocationLabel = 'City, Airport or Address';
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    isLandingPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        pt: [
                            2,
                            null,
                            null,
                            4
                        ],
                        pr: [
                            2,
                            null,
                            null,
                            4
                        ],
                        pl: 2,
                        pb: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeading/* default */.Z, {
                                fontSize: [
                                    3,
                                    4,
                                    null,
                                    null,
                                    5
                                ],
                                textStyle: isPricelineOnly ? [
                                    'heading4',
                                    null,
                                    'heading2'
                                ] : undefined,
                                color: isPricelineOnly ? 'text.heading' : primaryFontColor,
                                text: isPricelineOnly ? headline : partnerPrimaryHeading,
                                tag: "h1",
                                mb: 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeading/* default */.Z, {
                                textStyle: isPricelineOnly ? [
                                    'subheading6',
                                    null,
                                    'subheading4'
                                ] : undefined,
                                color: secondaryFontColor || 'text.light',
                                text: isPricelineOnly ? subheadline : partnerSecondaryHeading,
                                tag: "h2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        children: [
                            rentalCarEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm_TripTypeRadios, {
                                watchTripType: watchTripType,
                                setValue: setValue,
                                register: register
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flexWrap: "wrap",
                                mx: -2,
                                children: [
                                    !(0,TripTypes/* isHotelPlusCar */.Up)(watchTripType) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        width: [
                                            1,
                                            null,
                                            isSingleHotel ? 1 : 1 / 2
                                        ],
                                        px: 2,
                                        mt: 3,
                                        children: allowedPartnerOrigins && allowedPartnerOriginMap && allowedPartnerAirports ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationSelector, {
                                            label: "Where from?",
                                            errorMessage: (ref = errors.startLocation) === null || ref === void 0 ? void 0 : ref.message,
                                            onChange: function(_, value) {
                                                setAllowedPartnerDestinations(allowedPartnerOriginMap[value.airportCode].map(function(code) {
                                                    return allowedPartnerAirports.find(function(airport) {
                                                        return airport.airportCode === code;
                                                    });
                                                }));
                                                if (watchEndLocation && watchStartLocation) {
                                                    setValue('endLocation', '');
                                                }
                                                setValue('startLocation', value);
                                            },
                                            locations: allowedPartnerOrigins,
                                            fieldWidth: "100%",
                                            fieldHeight: "56px",
                                            hasShadowEffect: true
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                            enabled: true,
                                            forProperty: "startLocation",
                                            children: function(param) {
                                                var disableShadowState = param.disableShadowState;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeAhead/* default */.Z, {
                                                    searchProduct: "packagesOrigin",
                                                    label: "Where from?",
                                                    placeholder: "Where from?",
                                                    searchKey: "startLocation",
                                                    setValue: setValue,
                                                    errors: errors,
                                                    disableShadowState: disableShadowState,
                                                    defaultSelectedItem: watchStartLocation,
                                                    ref: registerTabElement,
                                                    focusNextElement: focusNextElement
                                                });
                                            }
                                        })
                                    }),
                                    !isSingleHotel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        width: [
                                            1,
                                            null,
                                            (0,TripTypes/* isHotelPlusCar */.Up)(watchTripType) ? 1 : 1 / 2
                                        ],
                                        px: 2,
                                        mt: 3,
                                        children: allowedPartnerDestinations && (sameFlightHotelAndCarDestination || defaultHotelAndCarDestination && !(0,TripTypes/* isHotelPlusCar */.Up)(watchTripType)) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationSelector, {
                                            label: "Where to?",
                                            errorMessage: (ref11 = errors.endLocation) === null || ref11 === void 0 ? void 0 : ref11.message,
                                            onChange: function(_, value) {
                                                return setValue('endLocation', value);
                                            },
                                            locations: allowedPartnerDestinations,
                                            fieldWidth: "100%",
                                            fieldHeight: "56px",
                                            hasShadowEffect: true
                                        }, watchStartLocation === null || watchStartLocation === void 0 ? void 0 : watchStartLocation.id) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                            enabled: true,
                                            forProperty: "endLocation",
                                            children: function(param) {
                                                var disableShadowState = param.disableShadowState;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeAhead/* default */.Z, {
                                                    searchProduct: "packagesDestination",
                                                    label: "Where to?",
                                                    placeholder: "Where to?",
                                                    searchKey: "endLocation",
                                                    errors: errors,
                                                    setValue: setValue,
                                                    disableShadowState: disableShadowState,
                                                    defaultSelectedItem: watchEndLocation,
                                                    onItemSelect: function(item) {
                                                        // auto-populate RC location if not set yet
                                                        if (!watchRcLocation) {
                                                            setValue('rcLocation', item);
                                                        }
                                                    },
                                                    ref: registerTabElement,
                                                    focusNextElement: focusNextElement
                                                });
                                            }
                                        })
                                    })
                                ]
                            }),
                            isPricelineOnly && watchTripType.includes('FLY') && /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineBlockBox, {
                                mt: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: formatOneWayHref({
                                        watchTripType: watchTripType,
                                        watchStartLocation: watchStartLocation,
                                        watchEndLocation: watchEndLocation,
                                        watchStartDate: watchStartDate,
                                        watchEndDate: watchEndDate,
                                        watchRoomCount: watchRoomCount,
                                        watchAdultCount: watchAdultCount,
                                        watchChildrenCount: watchChildrenCount,
                                        watchChildrenAges: watchChildrenAges,
                                        watchHotelStartDate: watchHotelStartDate,
                                        watchHotelEndDate: watchHotelEndDate,
                                        watchPartialStay: watchPartialStay,
                                        watchIncludeBasicEconomy: watchIncludeBasicEconomy
                                    }),
                                    target: "_blank",
                                    onClick: trackOneWayFlightLinkClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                        fontWeight: "bold",
                                        children: "I need a one-way flight"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flexWrap: "wrap",
                                alignItems: "flex-start",
                                mx: -2,
                                mb: -3,
                                pb: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        width: [
                                            1,
                                            null,
                                            null,
                                            null,
                                            2 / 3
                                        ],
                                        flexWrap: "wrap",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CalenderWrapperBox_styled/* default */.Z, {
                                                px: 2,
                                                mt: 3,
                                                width: [
                                                    1,
                                                    null,
                                                    1 / 2
                                                ],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                    enabled: true,
                                                    forProperty: "startDate",
                                                    children: function(param3) {
                                                        var disableShadowState = param3.disableShadowState;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* PopoverContainer */.OI, {
                                                            "data-calendar": true,
                                                            open: isCalendarOpen,
                                                            onDismiss: function() {
                                                                setIsCalendarOpen(false);
                                                                disableShadowState();
                                                            },
                                                            domSelectorForVisuallyContainedElement: utils/* CALENDAR_POPOVER_SELECTOR */.k7,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateField/* default */.Z, {
                                                                    name: "travelDates",
                                                                    "data-testid": "packages-date-range",
                                                                    label: (0,TripTypes/* isHotelPlusCar */.Up)(watchTripType) ? 'Check-in   -   Check-out' : 'Departing - Returning',
                                                                    ref: registerTabElement,
                                                                    value: (0,date_helper/* getPackagesDateRange */.Q0)({
                                                                        startDate: watchStartDate,
                                                                        endDate: watchEndDate
                                                                    }),
                                                                    onFocus: function() {
                                                                        setIsCalendarOpen(true);
                                                                    },
                                                                    error: function() {
                                                                        if (errors.startDate) {
                                                                            return errors.startDate.message;
                                                                        }
                                                                        if (errors.endDate) {
                                                                            return errors.endDate.message;
                                                                        }
                                                                    }(),
                                                                    hideTooltip: false,
                                                                    isMobile: isMobile,
                                                                    "aria-expanded": isCalendarOpen ? 'true' : 'false'
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Calendar */.f, {
                                                                    monthWidth: 300,
                                                                    startDate: watchStartDate,
                                                                    endDate: watchEndDate,
                                                                    onChange: function(_, param) {
                                                                        var startDate = param.startDate, endDate = param.endDate;
                                                                        if (startDate && endDate) {
                                                                            setIsCalendarOpen(false);
                                                                            disableShadowState();
                                                                        }
                                                                        setValue('startDate', startDate || '');
                                                                        setValue('endDate', endDate || '');
                                                                        setValue('hotelStartDate', startDate || '');
                                                                        setValue('hotelEndDate', endDate || '');
                                                                        // auto-populate RC dates if not set yet
                                                                        if (!watchRcPickupDate) setValue('rcPickupDate', startDate);
                                                                        if (!watchRcDropoffDate) setValue('rcDropoffDate', endDate);
                                                                    },
                                                                    useDefaultFooter: true,
                                                                    onDismiss: function() {
                                                                        setIsCalendarOpen(false);
                                                                        disableShadowState();
                                                                    }
                                                                })
                                                            ]
                                                        });
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                px: 2,
                                                mt: 3,
                                                width: [
                                                    1,
                                                    null,
                                                    1 / 2
                                                ],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                    enabled: true,
                                                    forProperty: "travelers-selection-readonly-input",
                                                    alternativeBlurHandling: true,
                                                    children: function(param) {
                                                        var disableShadowState = param.disableShadowState;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelerSelection/* default */.Z, {
                                                            disclaimer: constants/* VP_DISCLAIMER */.sP,
                                                            onDoneButtonClick: disableShadowState,
                                                            roomCount: watchRoomCount,
                                                            adultCount: watchAdultCount,
                                                            childrenAges: watchChildrenAges,
                                                            childrenCount: watchChildrenCount,
                                                            showChildAgeSelectors: true,
                                                            showRoomMenuItem: (0,TripTypes/* hasHotel */.$l)(watchTripType),
                                                            showSubLabel: false,
                                                            setValue: setValue,
                                                            disableShadowState: disableShadowState,
                                                            isMobile: isMobile,
                                                            error: isInfantOnInternationalTravel(watchStartLocation, watchEndLocation, watchChildrenAges) || isInfantLimitReachedPackages(watchAdultCount, watchChildrenAges, watchTripType) || isChildrenAgeProvided(watchChildrenCount, watchChildrenAges) || isRoomCompacityReached(watchAdultCount, watchChildrenCount, watchTripType, watchRoomCount, isMoreRoomCapacityAllowed),
                                                            infantCount: 0,
                                                            showInfantMenuItem: false,
                                                            showYouthMenuItem: false,
                                                            youthCount: 0
                                                        });
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                mt: 2,
                                                width: 1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        ml: 1,
                                                        flexWrap: [
                                                            'wrap',
                                                            null,
                                                            'nowrap'
                                                        ],
                                                        children: [
                                                            !isSingleHotel && !(0,TripTypes/* isHotelPlusCar */.Up)(watchTripType) && (0,TripTypes/* hasHotel */.$l)(watchTripType) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexLabel, {
                                                                nowrap: true,
                                                                fontSize: 0,
                                                                mr: 2,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                                        id: "packages-partial-stay",
                                                                        name: "partialStay",
                                                                        ref: register
                                                                    }),
                                                                    ' ',
                                                                    "I only need a hotel for part of my stay"
                                                                ]
                                                            }),
                                                            toggleBasicEconomyBoxEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexLabel, {
                                                                nowrap: true,
                                                                fontSize: 0,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                                        id: "package-include-basic-economy",
                                                                        "data-testid": "include-basic-economy-toggle",
                                                                        name: "includeBasicEconomy",
                                                                        ref: register
                                                                    }),
                                                                    ' ',
                                                                    "Show Basic Economy Fares"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    watchPartialStay && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        width: [
                                                            1,
                                                            null,
                                                            1 / 2
                                                        ],
                                                        mt: 2,
                                                        px: 2,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                            enabled: true,
                                                            forProperty: "hotelDates",
                                                            children: function(param4) {
                                                                var disableShadowState = param4.disableShadowState;
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* PopoverContainer */.OI, {
                                                                    "data-hotel-calendar": "true",
                                                                    domSelectorForVisuallyContainedElement: utils/* CALENDAR_POPOVER_SELECTOR */.k7,
                                                                    onDismiss: function() {
                                                                        setIsHotelCalendarOpen(false);
                                                                        disableShadowState();
                                                                    },
                                                                    open: isHotelCalendarOpen,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DateField/* default */.Z, {
                                                                            "aria-expanded": isHotelCalendarOpen ? 'true' : 'false',
                                                                            error: function() {
                                                                                if (errors.hotelStartDate) {
                                                                                    return errors.hotelStartDate.message;
                                                                                }
                                                                                if (errors.hotelEndDate) {
                                                                                    return errors.hotelEndDate.message;
                                                                                }
                                                                                if (errors.hotelStartDateInRange) {
                                                                                    return errors.hotelStartDateInRange.message;
                                                                                }
                                                                                if (errors.hotelEndDateInRange) {
                                                                                    return errors.hotelEndDateInRange.message;
                                                                                }
                                                                            }(),
                                                                            isMobile: isMobile,
                                                                            label: "Check-in - Check-out",
                                                                            name: "hotelDates",
                                                                            onFocus: function() {
                                                                                setIsHotelCalendarOpen(true);
                                                                            },
                                                                            value: (0,date_helper/* getPackagesDateRange */.Q0)({
                                                                                startDate: watchHotelStartDate !== null && watchHotelStartDate !== void 0 ? watchHotelStartDate : null,
                                                                                endDate: watchHotelEndDate !== null && watchHotelEndDate !== void 0 ? watchHotelEndDate : null
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Calendar */.f, {
                                                                            startDate: watchHotelStartDate,
                                                                            endDate: watchHotelEndDate,
                                                                            maxDate: watchEndDate ? (0,date_helper/* addFormattedDays */.r2)(watchEndDate, 1) : date_helper/* defaultMaxDate */.Vo,
                                                                            minDate: watchStartDate || date_helper/* defaultToday */.G4,
                                                                            monthWidth: 300,
                                                                            onChange: function(_, param) {
                                                                                var startDate = param.startDate, endDate = param.endDate;
                                                                                if (startDate && endDate) {
                                                                                    setIsHotelCalendarOpen(false);
                                                                                    disableShadowState();
                                                                                }
                                                                                setValue('hotelStartDate', startDate || '');
                                                                                setValue('hotelEndDate', endDate || '');
                                                                            },
                                                                            monthsToShow: watchStartDate && watchEndDate ? 1 : 2,
                                                                            onDismiss: function() {
                                                                                setIsHotelCalendarOpen(false);
                                                                                disableShadowState();
                                                                            },
                                                                            useDefaultFooter: true
                                                                        })
                                                                    ]
                                                                });
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0,TripTypes/* isHotelPlusCar */.Up)(watchTripType) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        flexWrap: "wrap",
                                        alignItems: "flex-start",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                mt: 2,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexLabel, {
                                                    nowrap: true,
                                                    fontSize: 0,
                                                    ml: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                            id: "packages-pickup-car-somewhere",
                                                            "data-testid": "packages-pickup-car-somewhere",
                                                            name: "pickupCarSomewhere",
                                                            ref: register
                                                        }),
                                                        ' ',
                                                        "I want to pick up my car somewhere else"
                                                    ]
                                                })
                                            }),
                                            watchPickupCarSomewhere && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                flexWrap: "wrap",
                                                alignItems: "flex-start",
                                                width: [
                                                    1,
                                                    null,
                                                    1
                                                ],
                                                px: 2,
                                                mt: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                        enabled: true,
                                                        forProperty: "rcLocation",
                                                        children: function(param) {
                                                            var disableShadowState = param.disableShadowState;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeAhead/* default */.Z, {
                                                                searchProduct: "cars",
                                                                label: carLocationLabel,
                                                                placeholder: carLocationLabel,
                                                                searchKey: "rcLocation",
                                                                "data-testid": "packages-rc-location",
                                                                errors: errors,
                                                                setValue: setValue,
                                                                disableShadowState: disableShadowState,
                                                                defaultSelectedItem: watchRcLocation !== null && watchRcLocation !== void 0 ? watchRcLocation : null,
                                                                ref: registerTabElement,
                                                                focusNextElement: focusNextElement
                                                            });
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                        mt: 2,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexLabel, {
                                                            nowrap: true,
                                                            fontSize: 0,
                                                            ml: -2,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                                    id: "packages-pickup-car-include-airport",
                                                                    name: "pickupCarIncludeAirport",
                                                                    ref: register
                                                                }),
                                                                ' ',
                                                                "Include airport pick-up and drop-off locations"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        flexWrap: "wrap",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CalenderWrapperBox_styled/* default */.Z, {
                                                                mt: 3,
                                                                width: [
                                                                    1 / 2,
                                                                    null,
                                                                    1 / 4
                                                                ],
                                                                "data-testid": "packages-rc-pickup-date",
                                                                id: "rc-pickup-date",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                                    enabled: true,
                                                                    forProperty: "rcPickupDate",
                                                                    children: function(param5) {
                                                                        var disableShadowState = param5.disableShadowState;
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* PopoverContainer */.OI, {
                                                                            "data-calendar": true,
                                                                            open: isRcPickupCalendarOpen,
                                                                            onDismiss: function() {
                                                                                setIsRcPickupCalendarOpen(false);
                                                                                disableShadowState();
                                                                            },
                                                                            domSelectorForVisuallyContainedElement: utils/* CALENDAR_POPOVER_SELECTOR */.k7,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateField/* default */.Z, {
                                                                                    name: "rcPickupDate",
                                                                                    label: "Pick-up",
                                                                                    ref: registerTabElement,
                                                                                    value: (0,date_helper/* formatDate */.p6)(watchRcPickupDate !== null && watchRcPickupDate !== void 0 ? watchRcPickupDate : null),
                                                                                    onFocus: function() {
                                                                                        setIsRcPickupCalendarOpen(true);
                                                                                    },
                                                                                    error: function() {
                                                                                        if (errors.rcPickupDate) {
                                                                                            return errors.rcPickupDate.message;
                                                                                        }
                                                                                    }(),
                                                                                    hideTooltip: false,
                                                                                    isMobile: isMobile,
                                                                                    "aria-expanded": isRcPickupCalendarOpen ? 'true' : 'false'
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Calendar */.f, {
                                                                                    monthsToShow: 2,
                                                                                    selectTwoDates: false,
                                                                                    maxDate: (0,date_helper/* getRcMaxDate */.U6)(watchRcDropoffDate),
                                                                                    startDate: watchRcPickupDate,
                                                                                    onChange: function(_, param) {
                                                                                        var startDate = param.startDate;
                                                                                        if (startDate) {
                                                                                            setIsRcPickupCalendarOpen(false);
                                                                                            disableShadowState();
                                                                                        }
                                                                                        setValue('rcPickupDate', startDate || '');
                                                                                    },
                                                                                    useDefaultFooter: true,
                                                                                    onDismiss: function() {
                                                                                        setIsRcPickupCalendarOpen(false);
                                                                                        disableShadowState();
                                                                                    }
                                                                                })
                                                                            ]
                                                                        });
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                px: 2,
                                                                mt: 3,
                                                                width: [
                                                                    1 / 2,
                                                                    null,
                                                                    1 / 4
                                                                ],
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                                    enabled: true,
                                                                    forProperty: "rcPickupTime",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeField, {
                                                                        id: "rc-pickup-time",
                                                                        "data-testid": "packages-rc-pickup-time",
                                                                        name: "rcPickupTime",
                                                                        label: "Pick-up Time",
                                                                        ref: register,
                                                                        style: {
                                                                            height: isMobile ? '46px' : '56px'
                                                                        },
                                                                        value: watchRcPickupTime,
                                                                        onChange: function(e) {
                                                                            setValue('rcPickupTime', e.currentTarget.value);
                                                                            e.target.blur();
                                                                        }
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CalenderWrapperBox_styled/* default */.Z, {
                                                                mt: 3,
                                                                width: [
                                                                    1 / 2,
                                                                    null,
                                                                    1 / 4
                                                                ],
                                                                id: "rc-dropoff-date",
                                                                "data-testid": "packages-rc-dropoff-date",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                                    enabled: true,
                                                                    forProperty: "rcDropoffDate",
                                                                    children: function(param6) {
                                                                        var disableShadowState = param6.disableShadowState;
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* PopoverContainer */.OI, {
                                                                            "data-calendar": true,
                                                                            open: isRcDropoffCalendarOpen,
                                                                            onDismiss: function() {
                                                                                setIsRcDropoffCalendarOpen(false);
                                                                                disableShadowState();
                                                                            },
                                                                            domSelectorForVisuallyContainedElement: utils/* CALENDAR_POPOVER_SELECTOR */.k7,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateField/* default */.Z, {
                                                                                    name: "rcDropoffDate",
                                                                                    label: "Drop-off",
                                                                                    ref: registerTabElement,
                                                                                    value: (0,date_helper/* formatDate */.p6)(watchRcDropoffDate !== null && watchRcDropoffDate !== void 0 ? watchRcDropoffDate : null),
                                                                                    onFocus: function() {
                                                                                        setIsRcDropoffCalendarOpen(true);
                                                                                    },
                                                                                    error: function() {
                                                                                        if (errors.rcDropoffDate) {
                                                                                            return errors.rcDropoffDate.message;
                                                                                        }
                                                                                    }(),
                                                                                    hideTooltip: false,
                                                                                    isMobile: isMobile,
                                                                                    "aria-expanded": isRcDropoffCalendarOpen ? 'true' : 'false'
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Calendar */.f, {
                                                                                    monthsToShow: 2,
                                                                                    selectTwoDates: false,
                                                                                    minDate: (0,date_helper/* getRcMinDate */.D$)(watchRcPickupDate),
                                                                                    startDate: watchRcDropoffDate,
                                                                                    onChange: function(_, param) {
                                                                                        var startDate = param.startDate;
                                                                                        if (startDate) {
                                                                                            setIsRcDropoffCalendarOpen(false);
                                                                                            disableShadowState();
                                                                                        }
                                                                                        setValue('rcDropoffDate', startDate || '');
                                                                                    },
                                                                                    useDefaultFooter: true,
                                                                                    onDismiss: function() {
                                                                                        setIsRcDropoffCalendarOpen(false);
                                                                                        disableShadowState();
                                                                                    }
                                                                                })
                                                                            ]
                                                                        });
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                px: 2,
                                                                mt: 3,
                                                                width: [
                                                                    1 / 2,
                                                                    null,
                                                                    1 / 4
                                                                ],
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                                    enabled: true,
                                                                    forProperty: "rcDropoffTime",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeField, {
                                                                        id: "rc-dropoff-time",
                                                                        name: "rcDropoffTime",
                                                                        "data-testid": "packages-rc-dropoff-time",
                                                                        label: "Drop-off Time",
                                                                        ref: register,
                                                                        style: {
                                                                            height: isMobile ? '46px' : '56px'
                                                                        },
                                                                        value: watchRcDropoffTime,
                                                                        onChange: function(e) {
                                                                            setValue('rcDropoffTime', e.currentTarget.value);
                                                                            e.target.blur();
                                                                        }
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                flexWrap: "wrap",
                                                width: [
                                                    1,
                                                    null,
                                                    null,
                                                    null,
                                                    1
                                                ],
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        width: [
                                                            1,
                                                            null,
                                                            1 / 2
                                                        ],
                                                        px: 2,
                                                        mt: 3,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFormButton/* default */.Z, {
                                                            buttonText: buttonText,
                                                            isMobile: isMobile,
                                                            "data-testid": "find-your-trip-button"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        width: [
                                                            1,
                                                            null,
                                                            0.4
                                                        ],
                                                        px: 2,
                                                        mt: 3,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                                            fontSize: "12px",
                                                            mt: 2,
                                                            children: callToAction
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !(0,TripTypes/* isHotelPlusCar */.Up)(watchTripType) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        flexDirection: "column",
                                        width: [
                                            1,
                                            null,
                                            null,
                                            null,
                                            1 / 3
                                        ],
                                        px: 2,
                                        mt: 3,
                                        ml: "auto",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFormButton/* default */.Z, {
                                                buttonText: buttonText,
                                                isMobile: isMobile,
                                                "data-testid": "find-your-trip-button"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                                fontSize: "12px",
                                                mt: 2,
                                                children: callToAction
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var SearchForm_Form = (Form);


/***/ }),

/***/ 33271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ onSubmit; },
/* harmony export */   "GS": function() { return /* binding */ getTextString; },
/* harmony export */   "k7": function() { return /* binding */ CALENDAR_POPOVER_SELECTOR; },
/* harmony export */   "E3": function() { return /* binding */ initialState; },
/* harmony export */   "XU": function() { return /* binding */ fields; }
/* harmony export */ });
/* harmony import */ var _shared_utils_packages_search__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62599);
/* harmony import */ var _shared_utils_local_forage_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34917);
/* harmony import */ var _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80404);
/* harmony import */ var _TripTypes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6244);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var onSubmit = function(values) {
    var ANALYTICS_CATEGORY = values.gaCategory;
    var startLocation = values.startLocation, endLocation = values.endLocation, childrenAges = values.childrenAges, rest = _objectWithoutProperties(values, [
        "startLocation",
        "endLocation",
        "childrenAges"
    ]);
    var isPartialStayDateValid = !!rest.partialStay && (rest.hotelStartDate !== rest.startDate || rest.hotelEndDate !== rest.endDate);
    if ((startLocation === null || startLocation === void 0 ? void 0 : startLocation.type) === 'AIRPORT' && (startLocation === null || startLocation === void 0 ? void 0 : startLocation.lat) === 0 && (startLocation === null || startLocation === void 0 ? void 0 : startLocation.lon) === 0) {
        startLocation.type = 'GDS_CITY';
    }
    if ((endLocation === null || endLocation === void 0 ? void 0 : endLocation.type) === 'AIRPORT' && (endLocation === null || endLocation === void 0 ? void 0 : endLocation.lat) === 0 && (endLocation === null || endLocation === void 0 ? void 0 : endLocation.lon) === 0) {
        endLocation.type = 'GDS_CITY';
    }
    (0,_shared_utils_packages_search__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_objectSpread({
        startLocationObject: startLocation,
        endLocationObject: endLocation,
        childrenAges: childrenAges
    }, rest, {
        isPartialStayDateValid: isPartialStayDateValid && rest.tripType !== _TripTypes__WEBPACK_IMPORTED_MODULE_3__/* .STAY_DRIVE */ .Hl
    }));
    (0,_shared_utils_local_forage_helper__WEBPACK_IMPORTED_MODULE_1__/* .persistSearchData */ .al)(_shared_utils_local_forage_helper__WEBPACK_IMPORTED_MODULE_1__/* .PACKAGE_SEARCH_DATA */ .Tw, values);
    if (isPartialStayDateValid) {
        _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fireEvent */ .Z.fireEvent({
            category: ANALYTICS_CATEGORY,
            action: 'VP Search Button',
            label: 'Partial search'
        });
    }
    if (rest.isRecommendedTrip) {
        _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fireEvent */ .Z.fireEvent({
            category: ANALYTICS_CATEGORY,
            action: 'VP Search Button',
            label: 'Recommended Trip search'
        });
    }
    if (!isPartialStayDateValid && !rest.isRecommendedTrip) {
        _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fireEvent */ .Z.fireEvent({
            category: ANALYTICS_CATEGORY,
            action: 'VP Search Button',
            label: 'Normal search'
        });
    }
    if (rest.pickupCarSomewhere) {
        _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fireEvent */ .Z.fireEvent({
            action: 'H+C - Different Location Search',
            category: ANALYTICS_CATEGORY
        });
    }
    if (!rest.pickupCarIncludeAirport) {
        _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fireEvent */ .Z.fireEvent({
            action: 'Hide On Airport Inventory',
            category: ANALYTICS_CATEGORY
        });
    }
};

var getTextString = function(tripType) {
    return function(text) {
        switch(tripType){
            case _TripTypes__WEBPACK_IMPORTED_MODULE_3__/* .STAY_FLY_DRIVE */ .Ss:
                return "".concat(text, "hotel, flight and car");
            case _TripTypes__WEBPACK_IMPORTED_MODULE_3__/* .FLY_DRIVE */ .yv:
                return "".concat(text, "flight and car");
            case _TripTypes__WEBPACK_IMPORTED_MODULE_3__/* .STAY_DRIVE */ .Hl:
                return "".concat(text, "hotel and car");
            case _TripTypes__WEBPACK_IMPORTED_MODULE_3__/* .STAY_FLY */ .b:
            default:
                return "".concat(text, "hotel and flight");
        }
    };
};
var CALENDAR_POPOVER_SELECTOR = '[aria-label="Calendar navigation tooltip"]';
var initialState = {
    tripType: _TripTypes__WEBPACK_IMPORTED_MODULE_3__/* .STAY_FLY */ .b,
    partialStay: false,
    startLocation: null,
    endLocation: null,
    startDate: '',
    endDate: '',
    hotelStartDate: '',
    hotelEndDate: '',
    roomCount: 1,
    adultCount: 2,
    childrenCount: 0,
    childrenAges: [],
    isRecommendedTrip: false,
    includeBasicEconomy: true,
    pickupCarSomewhere: false,
    pickupCarIncludeAirport: true,
    rcLocation: null,
    rcPickupDate: '',
    rcDropoffDate: '',
    rcPickupTime: '10:00',
    rcDropoffTime: '10:00',
    gaCategory: ''
};
var fields = [
    'startLocation',
    'endLocation',
    'startDate',
    'endDate',
    'hotelStartDate',
    'hotelEndDate',
    'roomCount',
    'adultCount',
    'childrenCount',
    'childrenAges',
    'tripType',
    'includeBasicEconomy',
    'pickupCarSomewhere',
    'pickupCarIncludeAirport',
    'rcLocation',
    'rcPickupDate',
    'rcDropoffDate',
    'rcPickupTime',
    'rcDropoffTime',
    'gaCategory'
];


/***/ }),

/***/ 5527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StyledHeading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99278);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97331);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23720);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1377);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var StyledH1 = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"].h1 */ .Z.h1).withConfig({
    componentId: "sc-ca43ae5a-0"
})(_templateObject(), styled_system__WEBPACK_IMPORTED_MODULE_5__/* .textAlign */ .yd);
var StyledH2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"].h2 */ .Z.h2).withConfig({
    componentId: "sc-ca43ae5a-1"
})(_templateObject1(), styled_system__WEBPACK_IMPORTED_MODULE_5__/* .alignSelf */ .uk, styled_system__WEBPACK_IMPORTED_MODULE_5__/* .textAlign */ .yd, styled_system__WEBPACK_IMPORTED_MODULE_5__/* .fontWeight */ .Ue, styled_system__WEBPACK_IMPORTED_MODULE_5__/* .space */ .Dh);
var HEADINGS = {
    h1: StyledH1,
    h2: StyledH2
};
function StyledHeading(_param) {
    var _color = _param.color, color = _color === void 0 ? 'text.base' : _color, text = _param.text, _fontSize = _param.fontSize, fontSize = _fontSize === void 0 ? [
        3,
        4,
        null,
        5
    ] : _fontSize, textAlign = _param.textAlign, tag = _param.tag, textStyle = _param.textStyle, props = _objectWithoutProperties(_param, [
        "color",
        "text",
        "fontSize",
        "textAlign",
        "tag",
        "textStyle"
    ]);
    var Component = HEADINGS[tag];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z), _isMobile = ref.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var bold = isMobile ? '600' : '700';
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, _objectSpread({
        fontSize: fontSize,
        fontWeight: tag === 'h2' ? '400' : bold,
        textAlign: textAlign || 'left',
        color: color,
        textStyle: textStyle,
        m: 0
    }, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
            children: text
        })
    }));
};


/***/ }),

/***/ 25439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useContent; }
/* harmony export */ });
/* harmony import */ var _pcln_contentful_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57931);
/* harmony import */ var _useSeti__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22091);


function useContent(item) {
    var shouldFireImpression = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var setiName = (0,_useSeti__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(item === null || item === void 0 ? void 0 : item.experimentName, shouldFireImpression && (item === null || item === void 0 ? void 0 : item.experimentName) !== undefined);
    return (item === null || item === void 0 ? void 0 : item.experimentName) ? (0,_pcln_contentful_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(setiName, item) : item;
};


/***/ }),

/***/ 34752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useContentfulSearchFormHeadlines; }
/* harmony export */ });
/* harmony import */ var _pcln_contentful_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61388);
/* harmony import */ var _useContent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25439);


function useContentfulSearchFormHeadlines(name) {
    var shouldFireImpression = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var searchFormResponse = (0,_pcln_contentful_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(name);
    var searchForm = (0,_useContent__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(searchFormResponse, shouldFireImpression);
    return searchForm !== null && searchForm !== void 0 ? searchForm : null;
};


/***/ })

}]);